import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../Store';
import { ProductLicensesResource } from '../../../../../Types';
import Accordion from '../../../../../../Accordion';
import { Maybe, nothing, just } from 'maybeasy';
import { ProductLicenseResource } from '../../../../../Types';
import CopyIcon from '../../../../../../Cutesies/ListIcon';
import ModalStore from '../../../../../../Modal/Store';
import Title from './Title';
import ChangeProductLicenseWarningModal from './ChangeProductLicenseWarningModal';
import ActiveProductLicenses from './ActiveProductLicenses';
import InActiveProductLicenses from './InActiveProductLicenses';
import { CustomizeState } from '../../../Store/Types';
import ModalReactions from '../../../../../../Modal/ModalReactions';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
  productLicensesResource: ProductLicensesResource;
}

interface State {
  productLicense: Maybe<ProductLicenseResource>;
}

class ChooseProductLicenseReady extends React.Component<Props> {
  modalStore: ModalStore = new ModalStore();
  state: State = { productLicense: nothing() };

  updateState = (productLicense: ProductLicenseResource) => {
    this.setState({ productLicense: just(productLicense) });
  };

  render(): React.ReactNode {
    const { store, productLicensesResource, state } = this.props;
    const { activeProductLicenses, inactiveProductLicenses } = productLicensesResource.payload;

    return (
      <div className="border-1 border-gray-200 rounded-md">
        <Accordion
          titleJSX={<Title selectedProductLicense={state.selectedProductLicense} />}
          titleIcon={<CopyIcon />}
          openByDefault={false}
          className="flex items-center justify-between rounded-md bg-white px-7 py-4"
        >
          <div className="mx-auto w-full max-w-clientPortalMaxWidth">
            <div className="px-2.5 pb-4 md:flex-row lg:px-7">
              <div className="pt-5">
                <ActiveProductLicenses
                  store={store}
                  modalStore={this.modalStore}
                  updateProductLicense={this.updateState}
                  state={state}
                  activeProductLicenses={activeProductLicenses}
                />
                <InActiveProductLicenses
                  store={store}
                  inactiveProductLicenses={inactiveProductLicenses}
                />
              </div>
            </div>
          </div>
        </Accordion>
        <ChangeProductLicenseWarningModal
          store={store}
          modalStore={this.modalStore}
          productLicense={this.state.productLicense}
        />
        <ModalReactions store={this.modalStore} />
      </div>
    );
  }
}

export default observer(ChooseProductLicenseReady);
